var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 11C11.2832 11 13.75 8.53325 13.75 5.5C13.75 2.46675 11.2832 0 8.25 0C5.21675 0 2.75 2.46675 2.75 5.5C2.75 8.53325 5.21675 11 8.25 11ZM8.25 0.916667C10.7773 0.916667 12.8333 2.97275 12.8333 5.5C12.8333 8.02725 10.7773 10.0833 8.25 10.0833C5.72275 10.0833 3.66667 8.02725 3.66667 5.5C3.66667 2.97275 5.72275 0.916667 8.25 0.916667ZM16.5 17.4167V22H15.5833V17.4167C15.5833 15.3945 13.9388 13.75 11.9167 13.75H4.58333C2.56117 13.75 0.916667 15.3945 0.916667 17.4167V22H0V17.4167C0 14.8894 2.05608 12.8333 4.58333 12.8333H11.9167C14.4439 12.8333 16.5 14.8894 16.5 17.4167Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullName);
export default __webpack_public_path__ + "static/media/fullName.11bd3602873ada159afa394f25bc2330.svg";
export { ForwardRef as ReactComponent };